import React, { useEffect, useState } from 'react'
import {
    IndexTable,
    LegacyCard,
    Text,
    Banner, BlockStack,
    Icon,
    InlineStack,
    Box,
    Select,
    useIndexResourceState,
    Modal,
    Tooltip,
    TextField,
} from '@shopify/polaris';
import { CircleInformationMajor, InfoMinor } from '@shopify/polaris-icons';
import { amazonReasons } from '../Utils/Constants';

function RefundModal(props: any) {
    const { open = false, refundmodalData, modalDataForFutureUse, setselectedRowIndexes, selectedRowIndexes, setRefundModalData, handleRefundOrderConfirmation, errors, rowSelection, setErrors, row, handleRefundModalClose } = props

    const title: any = <Text as="span"> <Text as='span' variant='bodyMd' fontWeight='semibold'>Failed Order Reason:</Text><Text as='span' variant='bodyMd'> {row?.refund_failed_reason}</Text></Text>;


    const GetModalInventory = (props: any) => {
        const { index, modalDataForFutureUse, data, refundmodalData } = props;
        return (
            <InlineStack gap="100" blockAlign='center' wrap={false}>
                <div style={{ minWidth: "80px" }}>
                    <Select
                        label=""
                        labelHidden
                        value={data?.refund_qty ? data?.refund_qty + "" : undefined}
                        onChange={(e) => {
                            let tempModalData = { ...refundmodalData };
                            tempModalData['items'][index]['refund_qty'] = parseInt(e);
                            tempModalData['items'][index]['refund_amount'] = "0";
                            setRefundModalData({ ...tempModalData });

                            let tempErrors = [...errors];
                            tempErrors[index]['refund_qty'] = e == "";
                            tempErrors[index]['refund_amount'] = true;
                            setErrors([...tempErrors])
                        }}
                        disabled={!selectedRowIndexes.includes(data?.['id'])}
                        options={[{ label: "Please Select", value: "", disabled: true }, ...Array.from({ length: data?.qty }, (_, i) => i + 1).map((num: number) => { return { label: num + "", value: num + "" } })]}
                        error={errors?.[index]?.['refund_qty']}
                    />
                </div>
                {modalDataForFutureUse?.items?.[index]?.refund_qty &&
                    <div className='toolTipScroll1' onMouseEnter={() => disable("inventory", index)} onMouseOver={() => disable("inventory", index)}>
                        <Tooltip content={<InlineStack wrap={false}><Text as='span'>Inventory refunded on shopify: </Text> <Text as='span' tone='subdued'> {modalDataForFutureUse?.items?.[index]?.refund_qty}</Text></InlineStack>}>
                            <Icon source={CircleInformationMajor} tone={'subdued'} />
                        </Tooltip>
                    </div>}
            </InlineStack>
        )
    }
    const { amazonReasonsOpt } = amazonReasons();
    const GetModalRefundReason = ((props: any) => {
        const { data, index } = props;
        return <Select
            label=""
            labelHidden
            value={refundmodalData?.items?.[index]?.refund_reason ?? ""}
            onChange={(e) => {
                let tempModalData = { ...refundmodalData };
                tempModalData['items'][index]['refund_reason'] = e;
                setRefundModalData({ ...tempModalData })
                let tempErrors = [...errors];
                tempErrors[index]['refund_reason'] = e == "";
                setErrors([...tempErrors])
            }}
            disabled={!selectedRowIndexes.includes(data['id'])}
            options={amazonReasonsOpt}
            error={errors?.[index]?.['refund_reason']} />
    })


    const getAdditionalPrices = (currency: string, data: any, item: any) => {
        let jsx: any = "";

        if (data?.additional_prices && Array.isArray(data?.additional_prices) && data?.additional_prices?.length > 0) {
            jsx = data?.additional_prices?.map((obj: any, idx: number) => {
                const tax = +((Math.floor(item?.tax?.marketplace_price / item?.qty * 1000) / 1000) ?? 0);
                const qty = +(item?.refund_qty ?? 0);
                return <InlineStack gap="100" key={obj?.code ?? idx}>
                    <Text as='p'>{obj?.code} : </Text>
                    <Text as='p' tone='subdued'>{currency} {(tax * qty).toFixed(2) ?? 0.00}</Text>
                </InlineStack>
            })
        }
        return jsx;
    }
    const getRefundToolTipContent = (currency: string, data: any, item: any) => {
        data = data?.items[0];
        return (
            <BlockStack gap="100">
                <InlineStack gap="100">
                    <Text as='p'>Item Price : </Text>
                    <Text as='p' tone='subdued'>{currency} {data?.['price']?.['marketplace_price'] ?? 0.00}</Text>
                </InlineStack>
                <InlineStack gap="100">
                    <Text as='p'>Item Discount : </Text>
                    <Text as='p' tone='subdued'>{currency} {data?.['discount']?.['marketplace_price'] ?? 0.00}</Text>
                </InlineStack>
                {getAdditionalPrices(currency, data, item)}
            </BlockStack>
        )
    }
    function preventScroll(e: any) {
        e.preventDefault();
        e.stopPropagation();
        return false;
    }
    function disable(type: string, index: number) {
        if (type == "inventory") {
            let icon = document.getElementsByClassName('toolTipScroll1')[index];
            icon?.addEventListener('wheel', preventScroll);
        }
        else {
            let icon = document.getElementsByClassName('toolTipScroll')[index];
            icon?.addEventListener('wheel', preventScroll);
        }
        let myElem = document.getElementsByClassName('Polaris-PositionedOverlay')[0]
        myElem?.addEventListener('wheel', preventScroll);
    }


    const { selectedResources, allResourcesSelected, handleSelectionChange } =
        useIndexResourceState(refundmodalData?.items);


    const rowMarkup = refundmodalData?.items?.map(
        (data: any, index: number) => {
            const item = refundmodalData?.items?.[index];
            const price = +(item?.price?.marketplace_price ?? 0);
            const qty = +(item?.refund_qty ?? 0);
            const tax = +(item?.tax?.marketplace_price / item?.qty ?? 0);
            const shipping = +(item?.shipping_charge?.marketplace_price ?? 0);
            const discount = +(item?.discount?.marketplace_price ?? 0);
            const total = Math.floor((price * qty + (tax * qty) + shipping - discount) * 1000) / 1000;
            // let tempModalData = { ...refundmodalData };
            // tempModalData['items'][index]['refund_amount'] = total;

            return <IndexTable.Row id={data['id']} key={index} position={index} selected={selectedRowIndexes.includes(data['id'])} onClick={() => { }}>
                <IndexTable.Cell>
                    <div style={{ minWidth: "220px" }}>
                        <Text variant="bodyMd" fontWeight="bold" as="span">
                            {data?.title}
                        </Text>
                    </div>
                </IndexTable.Cell>
                <IndexTable.Cell>
                    <InlineStack gap={"100"} blockAlign='center'>
                        {/* <div style={{ minWidth: "80px" }}> */}
                        {/* <div> */}
                        {/* <InlineStack wrap={false}> */}
                        <GetModalInventory modalDataForFutureUse={modalDataForFutureUse} refundmodalData={refundmodalData} data={data} index={index} />
                        {/* <span><Icon source={InfoMinor} tone='subdued' /></span> */}
                        {/* </InlineStack> */}
                        {/* </div> */}
                    </InlineStack>
                </IndexTable.Cell>
                <IndexTable.Cell>
                    <div style={{ minWidth: "200px" }}>
                        <GetModalRefundReason data={{ ...data }} index={index} />
                    </div>
                </IndexTable.Cell>
                <IndexTable.Cell>
                    <InlineStack gap="200" blockAlign='center' wrap={false}>
                        <Text as='p'>
                            {total}
                        </Text>
                        <div className='toolTipScroll' onMouseEnter={() => disable("pricing", index)} onMouseOver={() => disable("pricing", index)}>
                            <Tooltip content={getRefundToolTipContent(refundmodalData?.currency, { ...refundmodalData }, data)}>
                                <Icon source={CircleInformationMajor} tone={'subdued'} />
                            </Tooltip>
                        </div>
                    </InlineStack>
                </IndexTable.Cell>
                <IndexTable.Cell>
                    <div style={{ minWidth: "120px" }}>
                        <GetModalRefundAmount total={total} refundmodalData={refundmodalData} setRefundModalData={setRefundModalData} errors={errors} setErrors={setErrors} selectedRowIndexes={selectedRowIndexes} data={{ ...data }} index={index}></GetModalRefundAmount>
                    </div>
                </IndexTable.Cell>
            </IndexTable.Row>
        },
    );



    return (
        <Modal loading={Object.keys(refundmodalData).length == 0} title={`Failed Order (${row?.marketplace_reference_id})`} primaryAction={{
            content: 'Confirm',
            onAction: handleRefundOrderConfirmation,
        }}
            secondaryActions={[
                {
                    content: 'Cancel',
                    onAction: () => handleRefundModalClose(),
                },
            ]} open={open} onClose={() => handleRefundModalClose()} size='large'>
            <Modal.Section>
                <div className='custom-failed-order__container'>
                    <BlockStack gap={"300"}>
                        <Banner tone='critical' title={title}>
                            {/* <BlockStack gap={"100"}>
                                <Text as='p' variant='bodySm' fontWeight='medium'>If the ordered product is available in App:</Text>
                                <BlockStack gap={"050"}>
                                    <Text as='p' variant='bodySm' fontWeight='regular'>a) Enter the product's in-app SKU to locate and associate it with its corresponding product in the app.</Text>
                                    <Text as='p' variant='bodySm' fontWeight='regular'>b) Once linked, click the "Create on Shopify" button to generate the order within your Shopify platform.</Text>
                                </BlockStack>
                            </BlockStack> */}
                        </Banner>
                        <InlineStack align='start'>
                            <Box background='bg-surface-selected' paddingInline={"400"} paddingBlock={"200"} borderWidth='050' borderColor='transparent' borderRadius='200'>
                                <Text as='span' variant='bodyMd' fontWeight='semibold'>Refund Reason on Shopify: </Text>
                                <Text as='span' variant='bodyMd'> {refundmodalData?.refund_reason ?? "--"}</Text>
                            </Box>
                        </InlineStack>
                        <LegacyCard>
                            <div className='custom-refund-modal__table'>
                                <IndexTable
                                    itemCount={refundmodalData?.items?.length}
                                    loading={Object.keys(refundmodalData).length == 0}
                                    headings={[
                                        { title: 'Item Name' },
                                        { title: 'Refund Inventory' },
                                        { title: 'Refund Reason(Amazon)' },
                                        { title: 'Total Item Price' },
                                        { title: 'Refund Amount' },
                                    ]}

                                    onSelectionChange={(a, selected: boolean, c, d) => {
                                        handleSelectionChange(a, selected, c, d)
                                        if (a == 'single') {
                                            if (selected) {
                                                setselectedRowIndexes([...selectedRowIndexes, c])
                                            } else {
                                                setselectedRowIndexes((prev: any) => {
                                                    const index = prev.indexOf(c);
                                                    if (index > -1) { // only splice array when item is found
                                                        prev.splice(index, 1); // remove the item
                                                        return [...prev]; // return the updated array (make a copy if needed)
                                                    } else {
                                                        return prev
                                                    }
                                                })
                                            }

                                        } else {
                                            if (selected) {
                                                let tempData: any = []
                                                refundmodalData?.items?.map((data: any) => {
                                                    tempData.push(data['id'])
                                                })
                                                setselectedRowIndexes([...tempData])
                                            } else {
                                                setselectedRowIndexes([])
                                            }


                                        }

                                    }}

                                    selectedItemsCount={
                                        allResourcesSelected ? 'All' : selectedResources.length
                                    }
                                >
                                    {rowMarkup}
                                </IndexTable>
                            </div>
                            <div>
                                <div className='custom-bottom-sticky__selectCount'>
                                    <InlineStack align='space-between' gap={"400"}>
                                        <Text as='p' variant='bodyLg'>{selectedRowIndexes?.length} of {refundmodalData?.['items']?.length} item(s) selected</Text>
                                        <Text as='p'>
                                            <Text as="span" variant='headingMd'>Total Refund Amount:</Text>
                                            <Text as="span" variant='bodyLg'> USD  {refundmodalData?.items?.reduce((sum: number, item: any) => {
                                                return selectedRowIndexes?.includes(item.id)
                                                    ? sum + (Number(item.refund_amount) || 0)
                                                    : sum;
                                            }, 0).toFixed(3)}</Text>
                                        </Text>
                                    </InlineStack>
                                </div>
                            </div>
                        </LegacyCard>
                        <InlineStack align='start'>
                            <Banner tone='warning' title='If you have already refunded this order on Amazon, do not refund it here, or you will not be able to sync.' />
                        </InlineStack>
                    </BlockStack>
                </div>
            </Modal.Section>
        </Modal>
    )
}



export default RefundModal


const GetModalRefundAmount = ((props: any) => {
    const { data, index, total, refundmodalData, selectedRowIndexes, setRefundModalData, errors, setErrors, } = props
    return <TextField
        type={'number'}
        label=""
        labelHidden
        selectTextOnFocus
        value={refundmodalData?.items?.[index]?.refund_amount ?? "0"}
        onChange={(e) => {
            let tempModalData = { ...refundmodalData };
            tempModalData['items'][index]['refund_amount'] = e;
            setRefundModalData({ ...tempModalData });

            let tempErrors = [...errors];
            if (e == "" || e.trim().length == 0 || e == '0') {
                tempErrors[index]['refund_amount'] = true;
            }
            else {
                tempErrors[index]['refund_amount'] = + e > total
            }
            setErrors([...tempErrors])
        }}
        disabled={!selectedRowIndexes.includes(data?.['id'])}
        autoComplete="off"
        placeholder='Enter refund amount'
        error={errors?.[index]?.['refund_amount']} />
})